import { CoordinatorService } from "./coordinator.service"
import { LogItem } from "./log-item"

export class Logs$ {
    logMap = new Map<string, LogItem[]>()


    constructor(public coords: CoordinatorService) { }

    preview(xitemIdLs: string[]) {
        const stg = this.coords.stage$.current!.tag

        this.coords.resultList$.activateSubset({
            idSet:new Set(xitemIdLs),
            title: this.coords.text("Logs"),
            prefix: "",
            icon: 'logs',
            class: 'selection-in-general',
            back: () => this.coords.stage$.set(stg),
            stage: "collection",
        });

        // const tDct = this.coords.autotag$
        //     .getConstantTags("selection", "main")

        // this.coords.autotag$.setConstant(tDct.set,
        //     new Set(xitemIdLs))
        // this.coords.autotag$.setConstant(tDct.isNot, false)
        // const st = this.coords.stage$.current!
        // this.coords.autotag$.setConstant(tDct.title, {
        //     prefix: this.coords.text(""),
        //     title: this.coords.text("Logs"),
        //     icon: "logs",
        //     hasCounter: true,
        //     class: "selection-in-general",
        //     back: () => {
        //         this.coords.stage$.set(st)
        //         this.dialog()
        //     }
        // })
        // this.coords.stage$.set("collection")
        // this.coords.display$.closeDialog()
    }

    dialog() {
        this.logMap.clear()
        this.coords.manifest$.post("log-data", this._context)
        this.coords.display$.dialog$.next({ action: "logs" })
    }

    private get _context() {
        return {
            userId: this.coords.user$.currentId,
            projectId: this.coords.project$.currentId,
            isCloud: this.coords.project$.current?.isCloud,
            stage: this.coords.stage$.current?.tag,
            activeItemId: this.coords.resultList$.activeItem?.id,
        }
    }

    manifestResponse(params: any) {

        const context = this._context
        const aciveItemLs: LogItem[] = []
        const projectLs: LogItem[] = []

        this.logMap.set("activeItem", aciveItemLs)
        this.logMap.set("project", projectLs)
        params.logMap.forEach((v: any) => {
            const lItm = new LogItem(this.coords, v)
            if (context.stage === "project")
                projectLs.push(lItm)
            else if (lItm.hasItem(context.activeItemId))
                aciveItemLs.push(lItm)
            else
                console.log("WWW", this._context)

        })
        this.coords.display$.markForCheck()
    }
}
